"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEthPrice = void 0;
const ethers_1 = require("ethers");
const types_1 = require("@framework/types");
const getEthPrice = (asset) => {
    const total = asset?.reduce((memo, current) => {
        if (current.tokenType === Object.values(types_1.TokenType).indexOf(types_1.TokenType.NATIVE).toString()) {
            return memo + (0, ethers_1.toBigInt)(current.amount);
        }
        return memo;
    }, (0, ethers_1.toBigInt)(0));
    return total || (0, ethers_1.toBigInt)(0);
};
exports.getEthPrice = getEthPrice;
//# sourceMappingURL=utils.js.map